import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Header from '../../../components/header/header';
import Footer from '../../../components/footer/footer';
import { getOrders } from '../../../services/orders.service';
import { FaCalendarAlt, FaSearch } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import { Tab, Tabs } from 'react-bootstrap';
import './MyOrders.css';
import { getOrderById, getQuickOrderForUser, resetCorrelationId } from '../../../services/sim.service';
import { getHomeRouterOrders } from '../../../services/homeRouters.service';
import { HomeRouterOrder } from '../../../../types';
import Button from '../../../components/design/buttons/Button';
import Card from '../../../components/design/cards/card';
import Rs from '../../../components/design/rs';
import { getPlanById } from '../../../services/plans.service';
import { DateRange, RangeKeyDict } from 'react-date-range';
import type { Range as DateRangeType } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import endOfDay from 'date-fns/endOfDay';
import arSA from 'date-fns/locale/ar-SA';
import enUS from 'date-fns/locale/en-US';
import i18n from '../../../../config/i18n';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';


// "id": 3661,
// "userId": "3a514635-b30f-4bc6-8a14-29d29f5790c3",
// "fullName": "test",
// "nationalId": "1234567890",
// "orderState": {
//     "nameAr": "بانتظار التفعيل",
//     "nameEn": "Waiting Activation",
//     "code": "600"
// },
// "selectedSimType": 1,
// "providerId": 14,
// "tygoOrderId": "14202f7f-5f9e-4de4-9dd1-f63340efb5e7",
// "providerOrderId": "894e4095-0a3a-4801-b574-171488ab0f34",
// "tygoCheckoutId": "3823572344372ACC653CA5C34EE5B1D1.uat01-vm-tx03",
// "planName": "سولو 240",
// "providerName": "سلام",
// "planId": "117",
// "orderTotalAmount": 276.00,
// "vatAmount": 0.00,
// "vatPercentage": 0.00,
// "phoneNumber": "512345678",
// "countryCode": "966",
// "createdAt": "2025-04-15T17:22:22.7336917",
// "idType": "1",
// "nationality": {
//     "id": 1,
//     "nameAr": "المملكة العربية السعودية",
//     "nameEN": "Saudi Arabia",
//     "tcc_Id": "113",
//     "countryCode": "966",
//     "alphaCode": "SAU",
//     "flagImageUrl": "https://storagetygo01.blob.core.windows.net/images/countries/saudi_arabia.png"
// },
// "location": {
//     "longitude": "0",
//     "latitude": "0",
//     "address": "",
//     "city": ""
// }

interface PlanDetails {
  validityTimeInDays: number;
  imageUrl: string;
  minutesInSideProvider: number;
  smSForCurrentProvider: number;
  localInternt: number;
  contractTypeName: string;
}

interface Order {
  id: number;
  planName: string;
  orderTotalAmount: number;
  status: string;
  createdAt: string;
  network: string;
  validityTimeInDays: number;
  imageUrl: string;
  localCall?: string;
  message?: string;
  internet?: string;
  type?: string;
  phoneNumber?: string;
  countryCode?: string;
  orderId?: string;
  providerId?: number;
  providerName?: string;
  planId?: string;
  tygoOrderId?: string;
  providerOrderId?: string;
  tygoCheckoutId?: string;
  reservedNumber?: string;
}

const MyOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [orders, setOrders] = useState<Order[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [activeTab, setActiveTab] = useState('issuing');
  const navigation = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [homeRouterOrders, setHomeRouterOrders] = useState<HomeRouterOrder[]>([]);
  const [hrSearchTerm, setHrSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState<DateRangeType[]>([
    {
      startDate: undefined,
      endDate: undefined,
      key: 'selection'
    }
  ]);
  const [showRangePicker, setShowRangePicker] = useState(false);

  useEffect(() => {
    fetchOrders();
    fetchHomeRouterOrders();
  }, [i18n.language]);

  const fetchHomeRouterOrders = async () => {
    try {
      const response = await getHomeRouterOrders(i18n.language);
      setHomeRouterOrders(response || []);
    } catch (error) {
      // endpoint not wired up yet -> just show the empty state
      console.error('Error fetching home router orders:', error);
      setHomeRouterOrders([]);
    }
  };

  const fetchOrders = async () => {
    try {
      const response = await getQuickOrderForUser();
      console.log('Fetched orders:', response);
      
      if (response) {
        const formattedOrders = await Promise.all(response.map(async (order: any) => {
          // Fetch plan details for each order
          let planDetails: PlanDetails | null = null;
          let orderDetails: any = null;
          if (order.planId) {
            try {
              const planResponse = await getOrderById(order.providerId, order.tygoOrderId, order.providerOrderId);
              orderDetails = planResponse;
              planDetails = planResponse.plan;
            } catch (error) {
              console.error('Error fetching plan details:', error);
            }
          }

          return {
            id: order.id,
            planName: order.planName,
            orderId: order.tygoOrderId,
            providerId: order.providerId,
            providerName: order.providerName,
            planId: order.planId,
            phoneNumber: order.phoneNumber,
            countryCode: order.countryCode,       
            orderTotalAmount: order.orderTotalAmount,
            status: order.orderState.nameEn,
            createdAt: new Date(order.createdAt).toISOString(),
            network: order.providerName,
            validityTimeInDays: planDetails?.validityTimeInDays || 0,
            imageUrl: planDetails?.imageUrl || '/media/svgs/sim.svg',
            localCall: planDetails?.minutesInSideProvider || '-',
            message: planDetails?.smSForCurrentProvider || '-',
            internet: planDetails?.localInternt ? `${(planDetails.localInternt/1000).toLocaleString()} GB` : '-',
            type: planDetails?.contractTypeName || '-',
            tygoOrderId: order.tygoOrderId,
            providerOrderId: order.providerOrderId,
            tygoCheckoutId: order.tygoCheckoutId,
            reservedNumber: orderDetails?.number?.number || '-',
            nationalId: order.nationalId,
            fullName: order.fullName,
            idType: order.idType,
          };
        }));
        setOrders(formattedOrders);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setError('Failed to fetch orders. Please try again later.');
    }
  };

  const filteredOrders = orders.filter(order => {
    const matchesSearch = order.planName.toLowerCase().includes(searchTerm.toLowerCase());
    const orderDate = new Date(order.createdAt);
    const { startDate, endDate } = dateRange[0];
    const matchesFrom = !startDate || orderDate >= startDate;
    const matchesTo = !endDate || orderDate <= endOfDay(endDate);
    return matchesSearch && matchesFrom && matchesTo;
  });

  const filteredHomeRouterOrders = homeRouterOrders.filter(order => {
    const name = order.planName || '';
    const matchesSearch = name.toLowerCase().includes(hrSearchTerm.toLowerCase());
    const orderDate = new Date(order.createdAt);
    const { startDate, endDate } = dateRange[0];
    const matchesFrom = !startDate || orderDate >= startDate;
    const matchesTo = !endDate || orderDate <= endOfDay(endDate);
    return matchesSearch && matchesFrom && matchesTo;
  });

  const getStatusBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'activated':
        return 'badge-success';
      case 'pending':
        return 'badge-warning';
      case 'cancelled':
        return 'badge-danger';
      case 'waiting activation':
        return 'badge-secondary';
      default:
        return 'badge-secondary';
    }
  };
  
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div
        style={{
          backgroundImage: "url(./media/hero/bg2.png)",
          backgroundColor: "#F7F7F7",
          minHeight: "100vh",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed"
        }}
        className="d-flex flex-column justify-content-between"
      >
        <div className="container">
          <Header />
          <Card
            noEdge
            inner={
              <div className="container py-5">
                <h1 className="mb-4">{t('my_orders.title')}</h1>

                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k || 'issuing')}
                  className="mb-4 custom-tabs"
                >
                  <Tab eventKey="issuing" title={t('my_orders.tabs.issuing')}>
                    <div className="search-filter-container mb-4">
                      <div className="search-box">
                        <FaSearch className="search-icon" />
                        <input
                          type="text"
                          placeholder={t('my_orders.search_placeholder') || ''}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="search-input"
                        />
                      </div>
                      <div className="date-filter">
                        <button
                          className="date-button"
                          onClick={() => setShowRangePicker(!showRangePicker)}
                        >
                          <FaCalendarAlt />
                          {dateRange[0].startDate instanceof Date && dateRange[0].endDate instanceof Date
  ? `${dateRange[0].startDate.toLocaleDateString()} - ${dateRange[0].endDate.toLocaleDateString()}`
  : t('my_orders.select_date_range')}
                        </button>
                        {showRangePicker && (
                          <div className="date-picker-container">
                            <div className={i18n.language === 'ar' ? 'rtl-date-range-wrapper' : ''}>
                              <DateRange
                                editableDateInputs={true}
                                onChange={item => setDateRange([item.selection])}
                                moveRangeOnFirstSelection={false}
                                ranges={dateRange}
                                maxDate={new Date()}
                                locale={i18n.language === 'ar' ? arSA : enUS}
                                className={i18n.language === 'ar' ? 'rtl-date-range' : ''}
                              />
                            </div>
                            {/* <button
                              className="btn btn-sm btn-primary mt-2"
                              onClick={() => setShowRangePicker(false)}
                            >
                              {t('my_orders.apply')}
                            </button> */}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Mobile View - Cards */}
                    <div className="orders-grid d-md-none">
                      {filteredOrders.map((order) => (
                        <div key={order.id} className="order-card">
                          <div className="order-card-header">
                            <img src={order.imageUrl} alt={order.planName} className="plan-image" />
                            <div className="order-info">
                              <h3 className="plan-name">{order.planName}</h3>
                              <span className={`status-badge ${getStatusBadgeClass(order.status)}`}>
                                {t(`my_orders.status.${order.status.toLowerCase()}`)}
                              </span>
                            </div>
                          </div>
                          
                          <div className="order-details">
                            <div className="detail-item">
                              <span className="label">{t('my_orders.price')}:</span>
                              <span className="value" style={{
                                fontWeight: 'bold',
                                color: '#3EB6AE',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '5px'
                              }}>{order.orderTotalAmount} <Rs size={18}/></span>
                            </div>
                            <div className="detail-item">
                              <span className="label">{t('my_orders.date')}:</span>
                              <span className="value">{new Date(order.createdAt).toLocaleDateString()}</span>
                            </div>
                            <div className="detail-item">
                              <span className="label">{t('my_orders.network')}:</span>
                              <span className="value">{order.network}</span>
                            </div>
                            <div className="detail-item">
                              <span className="label">{t('my_orders.validity')}:</span>
                              <span className="value">{order.validityTimeInDays} {t('my_orders.days')}</span>
                            </div>
                            <div className="detail-item">
                              <span className="label">{t('my_orders.reserved_number')}:</span>
                              <span className="value" dir="ltr">{order.reservedNumber || '-'}</span>
                            </div>
                          </div>

                          <button className="details-button"
                          // navigation(`/sim/order?tygoOrderId=${order.tygoOrderId}&providerId=${order.providerId}&providerOrderId=${order.providerOrderId}&id=${order.tygoCheckoutId}&planId=${order.planId}`)
                          onClick={() => navigate(`/sim/order?tygoOrderId=${order.tygoOrderId}&providerId=${order.providerId}&providerOrderId=${order.providerOrderId}&id=${order.tygoCheckoutId}&planId=${order.planId}`)} >
                            {t('my_orders.view_details')}
                          </button>
                        </div>
                      ))}
                    </div>

                    {/* Desktop View - Table */}
                    <div className="orders-table d-none d-md-block">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>{t('my_orders.order_number')}</th>
                            <th>{t('my_orders.name')}</th>
                            <th>{t('my_orders.price')}</th>
                            <th>{t('my_orders.date')}</th>
                            <th>{t('my_orders.local_call')}</th>
                            <th>{t('my_orders.message')}</th>
                            <th>{t('my_orders.internet')}</th>
                            <th>{t('my_orders.type')}</th>
                            <th>{t('my_orders.reserved_number')}</th>
                            <th>{t('my_orders.status_title')}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredOrders.map((order) => (
                            <tr key={order.id}>
                              <td>{order.id}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={order.imageUrl} alt={order.planName} className="plan-image me-2" style={{ width: '40px' }} />
                                  <span className="plan-name">{order.planName}</span>
                                </div>
                              </td>
                              <td className="price-value">
                                {order.orderTotalAmount} <Rs size={18}/></td>
                              <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                              <td>{order.localCall || '-'}</td>
                              <td>{order.message || '-'}</td>
                              <td>{order.internet || '-'}</td>
                              <td>{order.type || '-'}</td>
                              <td dir="ltr">{order.reservedNumber || '-'}</td>
                              <td>
                                <span className={`status-badge ${getStatusBadgeClass(order.status)}`}>
                                  {t(`my_orders.status.${order.status.toLowerCase()}`)}
                                </span>
                              </td>
                              <td>
                                <Button inner={t('my_orders.details')} color='primary-outline-primary' onClick={
                                  () =>
                                  {
                                    resetCorrelationId(order.planId);
                                    navigation(`/sim/order?tygoOrderId=${order.tygoOrderId}&providerId=${order.providerId}&providerOrderId=${order.providerOrderId}&id=${order.tygoCheckoutId}&planId=${order.planId}`)
                                  }
                                }/>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Tab>

                
                  <Tab eventKey="eSIMforTraveling" title={t("my_orders.tabs.esim_for_traveling")}>

                    <div className="p-4 text-center">
                      {/* <h3>eSIMforTraveling</h3>
                      <p>Content for eSIMforTraveling orders will be displayed here.</p> */}
                      
                    </div>
                  </Tab>

                  <Tab eventKey="homeRouters" title={t('my_orders.tabs.home_routers')}>
                  <div className="home-routers-orders">
                    <div className="search-filter-container mb-4">
                      <div className="search-box">
                        <FaSearch className="search-icon" />
                        <input
                          type="text"
                          placeholder={t('my_orders.search_placeholder') || ''}
                          value={hrSearchTerm}
                          onChange={(e) => setHrSearchTerm(e.target.value)}
                          className="search-input"
                        />
                      </div>
                      <div className="date-filter">
                        <button
                          className="date-button"
                          onClick={() => setShowRangePicker(!showRangePicker)}
                        >
                          <FaCalendarAlt />
                          {dateRange[0].startDate instanceof Date && dateRange[0].endDate instanceof Date
                            ? `${dateRange[0].startDate.toLocaleDateString()} - ${dateRange[0].endDate.toLocaleDateString()}`
                            : t('my_orders.select_date_range')}
                        </button>
                        {showRangePicker && (
                          <div className="date-picker-container">
                            <div className={i18n.language === 'ar' ? 'rtl-date-range-wrapper' : ''}>
                              <DateRange
                                editableDateInputs={true}
                                onChange={item => setDateRange([item.selection])}
                                moveRangeOnFirstSelection={false}
                                ranges={dateRange}
                                maxDate={new Date()}
                                locale={i18n.language === 'ar' ? arSA : enUS}
                                className={i18n.language === 'ar' ? 'rtl-date-range' : ''}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {filteredHomeRouterOrders.length === 0 ? (
                      <div className="p-5 text-center text-muted">
                        {t('my_orders.home_routers.no_orders')}
                      </div>
                    ) : (
                      <>
                        {/* Mobile View - Cards */}
                        <div className="orders-grid d-md-none">
                          {filteredHomeRouterOrders.map((order) => (
                            <div key={order.tygoOrderId} className="order-card">
                              <div className="order-card-header">
                                <div className="order-info">
                                  <h3 className="plan-name">{order.planName}</h3>
                                </div>
                              </div>

                              <div className="order-details">
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.home_routers.order_number')}:</span>
                                  <span className="value">{order.tygoOrderId}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.home_routers.amount_paid')}:</span>
                                  <span className="value" style={{
                                    fontWeight: 'bold',
                                    color: '#3EB6AE',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px'
                                  }}>{order.totalAmount} <Rs size={18}/></span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.date')}:</span>
                                  <span className="value">{new Date(order.createdAt).toLocaleDateString()}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.home_routers.customer_name')}:</span>
                                  <span className="value">{order.fullName}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.home_routers.email')}:</span>
                                  <span className="value">{order.email}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.home_routers.contact_number')}:</span>
                                  <span className="value">{order.contactNumber}</span>
                                </div>
                                <div className="detail-item">
                                  <span className="label">{t('my_orders.home_routers.city')}:</span>
                                  <span className="value">{order.city}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Desktop View - Table */}
                        <div className="orders-table d-none d-md-block">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>{t('my_orders.name')}</th>
                                <th>{t('my_orders.home_routers.order_number')}</th>
                                <th>{t('my_orders.home_routers.amount_paid')}</th>
                                <th>{t('my_orders.date')}</th>
                                <th>{t('my_orders.home_routers.customer_name')}</th>
                                <th>{t('my_orders.home_routers.email')}</th>
                                <th>{t('my_orders.home_routers.contact_number')}</th>
                                <th>{t('my_orders.home_routers.city')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredHomeRouterOrders.map((order) => (
                                <tr key={order.tygoOrderId}>
                                  <td>
                                    <span className="plan-name">{order.planName}</span>
                                  </td>
                                  <td>{order.tygoOrderId}</td>
                                  <td className="price-value">
                                    {order.totalAmount} <Rs size={18}/></td>
                                  <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                                  <td>{order.fullName}</td>
                                  <td>{order.email}</td>
                                  <td>{order.contactNumber}</td>
                                  <td>{order.city}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  </div>
                  </Tab>
                </Tabs>
              </div>}
              />
        </div>
        
          <Footer />
          
        </div>
      </>
  );
};

export default MyOrders;